var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDegreeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "certificate-solid",
    d: "M9.85.3a1.125,1.125,0,0,0-1.9.506L7.211,3.739l-2.906-.82A1.123,1.123,0,0,0,2.918,4.306l.82,2.906L.809,7.957a1.131,1.131,0,0,0-.811.8A1.1,1.1,0,0,0,.3,9.85l2.165,2.109L.3,14.068a1.125,1.125,0,0,0,.506,1.9l2.929.741-.82,2.906A1.123,1.123,0,0,0,4.306,21l2.906-.82.741,2.929a1.128,1.128,0,0,0,1.9.511l2.109-2.165,2.109,2.165a1.121,1.121,0,0,0,1.1.3,1.139,1.139,0,0,0,.8-.811l.741-2.929,2.906.82A1.123,1.123,0,0,0,21,19.613l-.82-2.906,2.929-.741a1.131,1.131,0,0,0,.811-.8,1.119,1.119,0,0,0-.3-1.1l-2.165-2.109L23.62,9.85a1.121,1.121,0,0,0,.3-1.1,1.139,1.139,0,0,0-.811-.8L20.18,7.211,21,4.306a1.123,1.123,0,0,0-1.387-1.387l-2.906.82L15.962.809A1.131,1.131,0,0,0,15.16,0a1.1,1.1,0,0,0-1.092.3L11.959,2.468Z",
    transform: "translate(0.041 0.041)",
    fill: "#686868"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDegreeIcon);
export default __webpack_public_path__ + "static/media/degree-icon.21bcfdb53e59abbc7f3cd54b59a4ff0f.svg";
export { ForwardRef as ReactComponent };